import React, { useState } from "react";
import { Table } from "antd";

const ImportHistory = () => {
  const [history, setHistory] = useState([
    {
      key: "1",
      fileName: "dobavljac1.xlsx",
      date: "2024-06-01",
      status: "Uspešno",
    },
    {
      key: "2",
      fileName: "dobavljac2.xml",
      date: "2024-06-02",
      status: "Greška",
    },
  ]);

  return (
    <Table dataSource={history}>
      <Table.Column title="Fajl" dataIndex="fileName" key="fileName" />
      <Table.Column title="Datum" dataIndex="date" key="date" />
      <Table.Column title="Status" dataIndex="status" key="status" />
    </Table>
  );
};

export default ImportHistory;
